/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Error_No_TextInputs */

const en_try_magic_error_no_text = /** @type {(inputs: Try_Magic_Error_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter some text first`)
};

const es_try_magic_error_no_text = /** @type {(inputs: Try_Magic_Error_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor ingresa algo de texto primero`)
};

/**
* | output |
* | --- |
* | "Please enter some text first" |
*
* @param {Try_Magic_Error_No_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_error_no_text = /** @type {((inputs?: Try_Magic_Error_No_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Error_No_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_error_no_text(inputs)
	return en_try_magic_error_no_text(inputs)
});